import {
  useGlobalComponentForModel,
  useOverrides
} from '@rhino-project/core/hooks';
import {
  ModelEditActions,
  ModelEditActionsProps,
  ModelEditActionCancel,
  ModelEditActionSave,
  ModelEditActionSaveShow,
  ModelEditActionsBase
} from './ModelEditActions';
import { useCallback, useMemo } from 'react';
import { ModalFooter } from '@heroui/react';

interface ModelEditModalActionProps {
  onModalClose?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSave?: (data: any) => void;
  onCancel?: () => void;
}

export const ModelEditModalActionSave = ({
  onModalClose,
  onSave
}: ModelEditModalActionProps) => {
  const handleSave = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data: any) => {
      if (onSave) onSave(data);

      onModalClose?.();
    },
    [onModalClose, onSave]
  );

  return <ModelEditActionSave onSave={handleSave} />;
};

export const ModelEditModalActionSaveShow = ({
  onModalClose,
  onSave
}: ModelEditModalActionProps) => {
  const handleSave = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data: any) => {
      if (onSave) onSave(data);

      onModalClose?.();
    },
    [onModalClose, onSave]
  );

  return <ModelEditActionSaveShow onSave={handleSave} />;
};

export const ModelEditModalActionCancel = ({
  onModalClose,
  onCancel
}: ModelEditModalActionProps) => {
  const handleCancel = useCallback(() => {
    if (onCancel) onCancel();

    onModalClose?.();
  }, [onModalClose, onCancel]);

  return <ModelEditActionCancel onCancel={handleCancel} />;
};

const defaultComponents = {
  ModelEditModalActionSave,
  ModelEditModalActionCancel
};

export interface ModelEditModalActionsProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  overrides?: Record<string, any>;
  onModalClose?: () => void;
  [key: string]: unknown;
}

export const ModelEditModalActionsBase = ({
  overrides,
  onModalClose,
  ...props
}: ModelEditModalActionsProps) => {
  const { ModelEditModalActionSave, ModelEditModalActionCancel } = useOverrides(
    defaultComponents,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    overrides as Record<string, any>
  );

  const computedOverrides = useMemo(
    () => ({
      ModelEditActionSave: {
        component: ModelEditModalActionSave,
        props: { onModalClose }
      },
      ModelEditActionCancel: {
        component: ModelEditModalActionCancel,
        props: { onModalClose }
      }
    }),
    [ModelEditModalActionSave, ModelEditModalActionCancel, onModalClose]
  );

  return (
    <ModalFooter>
      <ModelEditActions
        style={{ gap: 5 }}
        overrides={computedOverrides}
        {...props}
      />
    </ModalFooter>
  );
};

const MODAL_EDIT_SAVESHOW_OVERRIDES = {
  ModelEditActionSave: ModelEditModalActionSaveShow
};
export const ModelEditModalActionsSaveShow = (props: ModelEditActionsProps) => (
  <ModelEditActionsBase overrides={MODAL_EDIT_SAVESHOW_OVERRIDES} {...props} />
);

export const ModelEditModalActions = (props: ModelEditModalActionsProps) =>
  useGlobalComponentForModel(
    'ModelEditModalActions',
    ModelEditModalActionsBase,
    props
  );
